import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles<{ linkUrlToText: boolean }>()(
  (theme, { linkUrlToText }) => ({
    subRowText: {
      fontSize: '12px',
      fontWeight: 400,
      color: theme.palette.labraText.description,
    },
    textWithLink: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: linkUrlToText ? 500 : 400,
      color: linkUrlToText ? theme.palette.select.light : '',
    },
    textCellWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(0.75),
    },
    linkWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    linkIcon: {
      width: theme.spacing(1.75),
      height: theme.spacing(1.875),
      marginLeft: theme.spacing(1.25),
      color: theme.palette.select.light,
    },
  })
)
